import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'aw-test-image-details-dialog',
  templateUrl: './test-image-details-dialog.component.html',
  styleUrls: ['./test-image-details-dialog.component.scss']
})
export class TestImageDetailsDialogComponent implements OnInit {

  constructor (
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
  }

}
